import { DOMHelper } from "../Helpers/DOMHelper.js";

export class ShiftFCAModule {

    constructor(shiftDatalayer) {        
        this.shiftDatalayer = shiftDatalayer;
        this.initiatedForms = {};// to remember and not double fire it
        this.enabled = false;
        this.providerName ='pixelmotion';
    }

    /**
     * 
     * @returns boolean true if it's enabled 
     */
    init() {        
        this.enabled = 'sd' in window;
        return this.enabled;
    }

    chatImpressionEvent({}) {        
        let eventName = 'chatImpression';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    chatClickEvent({}) {
        let eventName = 'chatClick';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    chatMessageEvent({chatMsgContent, chatMsgType}) {
        let eventName = 'chatUserMessage';
        console.info("PmDrsShift: " + eventName);
        sdDataLayer = this._getChatEventBaseObject(eventName);
        sdDataLayer.chatMessageType = chatMsgType || 'user';           
        sdDataLayer.chatMessageContent = chatMsgContent;           
        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    chatLeadEvent({chatLeadId}) {
        let eventName = 'chatLead';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);
        sdDataLayer.chatLeadId = chatLeadId;           

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;       
    }

    chatDrHandoffEvent({}) {//probably won't be used
        return;
        console.info("PmDrsShift: chatDrHandoff");

        sdDataLayer = { 
            chatProfitCenter: this.shiftDatalayer.getChatProfitCenter(),
            chatType: 'DR',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatDrHandoff'
        }

        sd('send');
        return sdDataLayer;
    }

    chatClosedEvent({}) {
        let eventName = 'chatClosed';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    _getChatEventBaseObject(event){
        var baseObject = {
            chatProfitCenter: this.shiftDatalayer.getChatProfitCenter(),
            chatType: 'text',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.providerName,
            events: event
        }
        return baseObject;
    }

}